// extracted by mini-css-extract-plugin
module.exports = {"socialLink":"social-link_socialLink__iIk_n","socialItem":"social-link_socialItem__H3_d4"};